// extracted by mini-css-extract-plugin
module.exports = {"Container":"empty-state-image_Container__j9PoY"};